import { useCallback, useEffect, useMemo, useState } from "react";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "../lib/api";
import { useSeo } from "../components/site/Layout";

export default function AdminSlots() {
  useSeo("Créneaux — admin");
  const [slots, setSlots] = useState(null);
  const [form, setForm] = useState({ date: "", time: "09:00", duration_min: 60 });
  const load = useCallback(() => adminApi.get("/slots").then((r) => setSlots(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const grouped = useMemo(() => {
    const m = new Map();
    (slots || []).forEach((s) => { if (!m.has(s.date)) m.set(s.date, { label: s.date_label, items: [] }); m.get(s.date).items.push(s); });
    return [...m.entries()];
  }, [slots]);
  const add = async (e) => {
    e.preventDefault();
    try { await adminApi.post("/slots", { ...form, duration_min: Number(form.duration_min) }); toast.success("Créneau ajouté"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const remove = async (s) => {
    try { await adminApi.delete(`/slots/${s.id}`); toast.success("Créneau supprimé"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <div data-testid="admin-slots">
      <h1 className="text-3xl sm:text-4xl">Créneaux de rendez-vous</h1>
      <form onSubmit={add} className="mt-6 rounded-2xl bg-white border border-slate-200 p-6 flex flex-wrap items-end gap-4" data-testid="slot-add-form">
        <label className="block"><span className="font-semibold text-navy">Date</span>
          <input type="date" required className="field-input mt-2" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="slot-add-date" /></label>
        <label className="block"><span className="font-semibold text-navy">Heure (Paris)</span>
          <input type="time" required className="field-input mt-2" value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} data-testid="slot-add-time" /></label>
        <label className="block"><span className="font-semibold text-navy">Durée (min)</span>
          <input type="number" min={15} max={240} step={15} className="field-input mt-2 w-28" value={form.duration_min} onChange={(e) => setForm({ ...form, duration_min: e.target.value })} data-testid="slot-add-duration" /></label>
        <button type="submit" className="btn-primary" data-testid="slot-add-submit"><Plus className="h-4 w-4" aria-hidden="true" /> Ajouter</button>
      </form>
      <div className="mt-8 space-y-4">
        {!slots && <p className="text-slate-600">Chargement…</p>}
        {grouped.map(([d, g]) => (
          <div key={d} className="rounded-2xl bg-white border border-slate-200 p-5" data-testid={`slot-day-${d}`}>
            <h2 className="font-sans text-navy capitalize">{g.label}</h2>
            <ul className="mt-3 flex flex-wrap gap-2">
              {g.items.map((s) => (
                <li key={s.id} data-testid={`admin-slot-${s.id}`} className={`flex items-center gap-2 rounded-full border px-4 py-1.5 ${s.booked ? "bg-brand-ink/10 border-brand/40 text-brand-ink" : "border-slate-300"}`}>
                  <span className="font-semibold">{s.time}</span>
                  {s.booked ? <span className="text-sm">réservé</span> : (
                    <button type="button" onClick={() => remove(s)} aria-label={`Supprimer le créneau ${s.time}`} data-testid={`slot-delete-${s.id}`} className="text-slate-500 hover:text-red-700"><Trash2 className="h-4 w-4" /></button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
